export default "__VITE_ASSET__zFXmRWG4__"